import React, { Suspense } from "react";
import { AuthProvider } from "./hooks/contexts/AuthContext";
import { RouterProvider } from "react-router-dom";
import PageLoading from "./PageLoading";
import { useMediaQuery } from "@mui/system";
import ApiDispatch from "./apiCalls/ApiDispatch";

// mobile Device Router
import { mobileRouter, router } from "./routes/routes";

function App() {
    const routes = useMediaQuery('(max-width:600px)') ? mobileRouter : router;
    return (
        <React.Fragment>
            <AuthProvider>
                <ApiDispatch />
                <Suspense fallback={<PageLoading />}>
                    <RouterProvider router={routes} />
                </Suspense>
            </AuthProvider>
        </React.Fragment>
    )

}

export default App;



// if (device) {
//   return (<MobileRedirect />);
// } else {
//   return (
//     <React.Fragment>
//       {/* <AllProductsFetch />
//       <BestSeller />
//       <FeaturedProducts />
//       <TopFiveProducts />
//       <EntertainmentProducts />
//       <SliderData /> */}

//       <AuthProvider>
//         <Suspense fallback={<PageLoading />}>
//           <RouterProvider router={router} />
//         </Suspense>
//       </AuthProvider>

//     </React.Fragment >
//   );
// }
